import React, { Component } from 'react';
import {Input,Modal, Form,Icon, Button, Select,Radio, DatePicker, InputNumber } from 'antd';
import {getWorkflow,getTask,getTaskwithoutworkflow} from '../../stores/APIEndpoints';
import looseLeafStore from "../../stores/LooseLeafStore";
import DashboardStore from '../../stores/DashboardStore';
import {appStore} from '../../stores/AppStore';
import {inject, observer} from 'mobx-react';
import '../../../src/index.css';
import moment from 'moment';

let slectmulDates = [];
@inject('dataStore')
@observer
class LooseLeafSchedulerDrawer extends Component {
  
    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        this.state = {
            selectWorkflow:'',
            selectTasks:'',
            selectedMultipleDates:[],
            visible: false,
            basedonatask:'BASEDONATASK',
            basedonthelastupdatedate:'BASEDONTHELASTUPDATEDATE',
            fixed:'FIXED',

          }
    }
    get store() {
        return DashboardStore;
      
    }
    async componentDidMount() {
    
        this.getTaskList();
        this.getWorkflowList();
        this.getMultipleList();
     
      }  
      getMultipleList = async()=>{
      
        const data = this.store.currentData;
        if(data.reseedFixedDates != null)
        {
        const reseedFixedDates = data.reseedFixedDates.split(',');
        if(reseedFixedDates[0]=="")
        {
          return;
        }
        slectmulDates = reseedFixedDates;
        this.setState({selectedMultipleDates:reseedFixedDates})
      
        }
      }
      getWorkflowList = async () => {
        const bodyParams = { "select": ["id", "name" ], "where": []};
        let response = await this.apiProxy.asyncPost(getWorkflow, bodyParams);
        const option = await response.json();
        this.setState({selectWorkflow:option});
     //   this.getTaskList();
      };
      // getTaskList = async() =>{
      //   const data = this.store.looseLeafSeed;
      //   if(data.globalWorkflowId != null)
      //   {
      //     const bodyParams = {"where": [data.globalWorkflowId]}
      //     let response = await this.apiProxy.asyncPost(getTask, bodyParams);
      //     const option = await response.json();
      //     this.setState({selectTasks:option});
      //   }
      // }
      
      getTaskList = async() =>{
        const data = this.store.currentData;
        const bodyParams = { "select": ["id", "name" ], "where": []};
          let response = await this.apiProxy.asyncPost(getTaskwithoutworkflow, bodyParams);
          const option = await response.json();
          this.setState({selectTasks:option});
        
      }




  handleSubmit = e => {
   
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
          let data={};
          data.globalWorkflowId =values.globalWorkflowId;
          data.reseedType = values.reseedType;
          if(values.projectStartDate !="" &&  values.projectStartDate != undefined)
          {
             //data.projectStartDate = values.projectStartDate.year()+'-'+(values.projectStartDate.month()+1)+'-'+values.projectStartDate.date();
             data.projectStartDate = moment(values.projectStartDate).format('YYYY-MM-DD');
            }
          else
          {
            this.store.currentData.projectStartDate = null;
            data.projectStartDate=null;
          }
          if(values.lastUpdatedDate !="" &&  values.lastUpdatedDate != undefined)
          {
           //data.lastUpdatedDate = values.lastUpdatedDate.year()+'-'+(values.lastUpdatedDate.month()+1)+'-'+values.lastUpdatedDate.date();
            data.lastUpdatedDate = moment(values.lastUpdatedDate).format('YYYY-MM-DD');
          }
          else{
            this.store.currentData.lastUpdatedDate = null;
            data.lastUpdatedDate =null;
          }
              data.msAbstractTaskId = values.msAbstractTaskId;
              data.msActor = 'Project Manager';
         // data.ifpDate = values.ifpDate;
          // data.cmpDate = values.cmpDate;
          if(data.reseedType == 'FIXED')
          {
             data.reseedFixedDates=values.reseedFixedDatesList.toString();
             data.recyclePeriod = 0;
          }
          else
          {
              data.abstractTaskId = values.abstractTaskId;
              data.recyclePeriod = values.recyclePeriod;
          }
          data.preReview = values.preReview;
          data.p1Status = values.p1Status;
          data.newsAlert = values.newsAlert;
          data.authorNames =this.store.currentData.future_author;
          data.authorEmails = this.store.currentData.future_authorEmails;
          data.cmNames = this.store.currentData.future_cm;
          data.cmEmails = this.store.currentData.future_cmEmails;
          data.editorNames = this.store.currentData.future_editor;
          data.editorEmails = this.store.currentData.future_editorEmails;
          this.store.updateItem(data);
     
      }
    });
  };
  onclickFinalized= e =>{
 
    this.props.form.validateFields((err, values) => {
      if (!err) {
          let data={};
         
          data.globalWorkflowId=values.globalWorkflowId;
          data.reseedType= values.reseedType;
          if(values.projectStartDate !="")
          {
            data.projectStartDate = values.projectStartDate.year()+'-'+(values.projectStartDate.month()+1)+'-'+values.projectStartDate.date();
            // data.filesToAuthorDate = values.filesToAuthorDate.year()+'-'+(values.filesToAuthorDate.month()+1)+'-'+values.filesToAuthorDate.date();
            // data.filesFromAuthorDate = values.filesFromAuthorDate.year()+'-'+(values.filesFromAuthorDate.month()+1)+'-'+values.filesFromAuthorDate.date();
          }
          data.msAbstractTaskId = values.msAbstractTaskId;
          data.msActor = 'Project Manager';

          // data.ifpDate = values.ifpDate;
          // data.cmpDate = values.cmpDate;

          if(data.reseedType == 'FIXED')
          {
          data.reseedFixedDates=values.reseedFixedDatesList.toString();
          }
          else
          {
          data.abstractTaskId = values.abstractTaskId;
          data.recyclePeriod = values.recyclePeriod;
        }
        this.store.saveScheduleInfo(data)
     
      }
   
  });
}


  onChangeReseedType=(value)=>{
     this.store.currentData.reseedType = value; 
  }
  selectReseedFixedDates = (value) =>{
    //slectmulDates.push('YYYY-'+(value.month()+1)+'-'+value.date());
    slectmulDates.push(moment(value).format('[YYYY]-MM-DD'));
    this.setState({selectedMultipleDates:slectmulDates});
    //this.setState({selectedMultipleDates:[...this.state.selectedMultipleDates, value._d.toLocaleDateString()]});
  }
  selectedDatesChange = (value) => {
    slectmulDates=[];
    slectmulDates=value;
    this.setState({selectedMultipleDates:slectmulDates});
  }
//  onChangeWorkflow=(value)=>{
//    const data = this.store.currentData;
//    data.globalWorkflowId  = value;
//    this.getTaskList(); 
//  }
//  getRequestDate=async(value)=>{
//    if(this.store.looseLeafSeed.abbreviation != "MIP")
//    {
//       this.store.looseLeafSeed.filesToAuthorDate=value;
//       this.getFileToAuthor(value);
//    }
//    else if(this.store.looseLeafSeed.abbreviation == "MIP")
//    {
//     const newdate = new Date(value);
//     let dateCount = await this.mapToWorkdays(newdate, 15);
//     let filesToAuthorDate = new Date(newdate.setDate(newdate.getDate() + dateCount));
//     this.store.looseLeafSeed.filesToAuthorDate=filesToAuthorDate
//     this.getFileToAuthor(filesToAuthorDate);
//    }
//  }
onchangeRecyclePeriod=async(values)=>{
  this.store.currentData.recyclePeriod = values;
}
onChangeLastUpdatedDate=async(values)=>{
  
  const newdate = new Date(values);
  if(this.store.currentData.reseedType == "BASEDONTHELASTUPDATEDATE")
     {
       if(this.store.currentData.recyclePeriod == 0 || this.store.currentData.recyclePeriod == "" || this.store.currentData.recyclePeriod == undefined ||  this.store.currentData.recyclePeriod == null)
       {
        message.error('Recycle period count is empty.');
        return false;
       }
      let dateCount = await this.mapToWorkdays(newdate, this.store.currentData.recyclePeriod);
      this.store.currentData.projectStartDate=new Date(newdate.setDate(newdate.getDate() + dateCount));
     }
 }
 
 onChangelastPublishedDate = async(values)=>{
   
  this.store.currentData.lastPublishedDate=values.format("YYYY-MM-DD");
  
 }

 mapToWorkdays=async(date, add)=> {
  const wd = this.weekday(date)
  
  let r = Math.trunc(add / 5) * 2
  const rem = add % 5

  if (wd > 4) r += (6-wd)
  else if (wd+rem > 4) r += 2
  
  return add + r;
}
weekday=(date)=> { return (date.getUTCDay()+ 6) % 7 }

//  getFileToAuthor=async(value)=>{
//     const newdate = new Date(value);
//     if(this.store.looseLeafSeed.abbreviation == "IEADA")
//     {
//       let dateCount = await this.mapToWorkdays(newdate, 25);
//       this.store.looseLeafSeed.filesFromAuthorDate=new Date(newdate.setDate(newdate.getDate() + dateCount));
//     }
//     else if(this.store.looseLeafSeed.abbreviation == "ENF")
//     {
//       let dateCount = await this.mapToWorkdays(newdate, 24);
//       this.store.looseLeafSeed.filesFromAuthorDate=new Date(newdate.setDate(newdate.getDate() + dateCount));
//     }
//     else if(this.store.looseLeafSeed.abbreviation == "ILEL")
//     {
//       let dateCount = await this.mapToWorkdays(newdate, 25);
//       this.store.looseLeafSeed.filesFromAuthorDate=new Date(newdate.setDate(newdate.getDate() + dateCount));
//     }
//     else if(this.store.looseLeafSeed.abbreviation == "EICLIT")
//     {
//       let dateCount = await this.mapToWorkdays(newdate, 24);
//       this.store.looseLeafSeed.filesFromAuthorDate=new Date(newdate.setDate(newdate.getDate() + dateCount));
//     }
//     else if(this.store.looseLeafSeed.abbreviation == "MLH")
//     {
//       let dateCount = await this.mapToWorkdays(newdate, 24);
//       this.store.looseLeafSeed.filesFromAuthorDate=new Date(newdate.setDate(newdate.getDate() + dateCount));
//     }
//     else if(this.store.looseLeafSeed.abbreviation == "NGTEST")
//     {
//       let dateCount = await this.mapToWorkdays(newdate, 6);
//       this.store.looseLeafSeed.filesFromAuthorDate=new Date(newdate.setDate(newdate.getDate() + dateCount));
//     }
//     else if(this.store.looseLeafSeed.abbreviation == "MIP")
//     {
//       let dateCount = await this.mapToWorkdays(newdate, 15);
//       this.store.looseLeafSeed.filesFromAuthorDate=new Date(newdate.setDate(newdate.getDate() + dateCount));
//     }
//  }

  // mipWorkflowChange=(value)=>{
  //    this.getMIPWorkflow();
  // }

  // getMIPWorkflow=()=>{
  //   this.props.form.validateFields((err, values) => {
  //     if (!err) {
  //       if(values.p1Status == false && values.preReview == true)
  //           {
  //             this.store.currentData.globalWorkflowId = 2655;
  //           }
  //           else if(values.p1Status == true && values.preReview == true)
  //           {
  //             this.store.currentData.globalWorkflowId = 3142;
  //           }
  //           else if(values.p1Status == false && values.preReview == false)
  //           {
  //             this.store.currentData.globalWorkflowId = 3132;
  //           }
  //           else if(values.p1Status == true && values.preReview == false)
  //           {
  //             this.store.currentData.globalWorkflowId = 3157;
  //           }
  //      }
  //   });
  // }

  render() {
     const { getFieldDecorator } = this.props.form;
     const data = this.store.currentData;
   
     const title = data.id === undefined ? "New Title" : data.abbreviation + " - " + data.publication;
     const {selectWorkflow,selectTasks,} = this.state;
    // const reseedFixedDates = data.reseedFixedDates.split(',');
    
    // if(reseedFixedDates != null)
    // {
    // this.setState({selectedMultipleDates:reseedFixedDates})
    // }BASEDONATASK , BASED ON THE LAST UPDATE DATE
  
    
  
    return (
        <Form name="normal_login"  className="login-form" initialValues={{ remember: true }} onSubmit={this.handleSubmit}>
        {data.abbreviation=='MIP'?
        <div>
        {/* <Form.Item label="Pre Review"  name="preReview">
            {getFieldDecorator('preReview', {
                 initialValue:data.preReview,
                 rules: []
            })(
              <Radio.Group onMouseLeave={this.mipWorkflowChange} disabled={data.stage=="In Acquisition"} >
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            )}
        </Form.Item> */}
        {/* <Form.Item label="P1 Status" name="p1Status">
            {getFieldDecorator('p1Status', {
                 initialValue:data.p1Status,
                 rules: []
            })(
              <Radio.Group onMouseLeave={this.mipWorkflowChange} disabled={data.stage=="In Acquisition"} >
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            )}
        </Form.Item> */}
        <Form.Item label="News Alert"  name="NewsAlert">
        {getFieldDecorator('newsAlert', {
           initialValue:data.newsAlert,
           rules: []
            })(
            <Select showSearch  placeholder="Select News Alert" optionFilterProp="children" onChange={this.onChangeNewsAlert}>
                <Option value={"There were no NewsAlerts for this country"}>None</Option>
                <Option value={"There were NewsAlerts and 6 topic check for this country"}>News alerts + 6 topic review</Option>
                <Option value={"There were only NewsAlerts for this country"}>News alerts</Option>
                <Option value={"There were only 6 topic check for this country"}>6 topic review</Option>
            </Select>
            )}
        </Form.Item>
        </div>:''}
        <Form.Item label="Workflow"  name="Workflow">
            {getFieldDecorator('globalWorkflowId', {
                 initialValue:data.globalWorkflowId,
                 rules: []
            })(
                <Select showSearch placeholder="Select a Workflow" optionFilterProp="children">
                {selectWorkflow != "" ? selectWorkflow.map(value =>  <Option value={value.id}>{value.name}</Option>) : <Option value=''>''</Option>}
                </Select>
            )}
        </Form.Item>
      
       {/* <Form.Item label="Pickup for next edition for Authors"  name="msAbstractTaskId">
         {getFieldDecorator('msAbstractTaskId', {
              initialValue:'132',
              rules: [{disabled: true}]
            })(
            <Select showSearch placeholder="select pickup for next edition for Authors" optionFilterProp="children" onChange={this.onChangePickupTask}>
               <Option value='132'>Final PDF & XML to Online Team</Option>
            </Select>
            )}
        </Form.Item> */}

        <Form.Item label="Pickup for next edition for Authors"  name="msAbstractTaskId">
         {getFieldDecorator('msAbstractTaskId', {
              initialValue:data.msAbstractTaskId,
              rules: []
            })(
            <Select showSearch placeholder="select pickup for next edition for Authors" optionFilterProp="children">
            {selectTasks != "" ? selectTasks.map(value =>  <Option value={value.id}>{value.name}</Option>) : <Option value=''>''</Option>}
            </Select>
            )}
        </Form.Item>

        {/* <Form.Item label="Milestones Actor"  name="msActor">
         {getFieldDecorator('msActor', {
              initialValue:data.msActor,
              rules: [{required: true}]
            })(
            <Select showSearch placeholder="Milestones Actor" optionFilterProp="children">
              <Option value='ProjectManager'>Project Manager</Option>
              <Option value='Reviewer'>Reviewer</Option>
            </Select>
            )}
        </Form.Item> */}
      
        <Form.Item label="Reseed Type"  name="ReseedType">
        {getFieldDecorator('reseedType', {
           initialValue:data.reseedType,
           rules: []
            })(
            <Select showSearch defaultValue="BASEDONATASK"  placeholder="Select a reseed type" optionFilterProp="children" onChange={this.onChangeReseedType}>
                <Option value={"BASEDONATASK"}>BASED ON A TASK</Option>
                <Option value={"FIXED"}>FIXED</Option>
                <Option value={"BASEDONTHELASTUPDATEDATE"}>BASED ON THE LAST UPDATE DATE</Option>
            </Select>
            )}
        </Form.Item>
        
             {data.reseedType == 'FIXED' ?       
         <Form.Item label="Reseed Fixed Dates" name="reseedFixedDatesList">
          {getFieldDecorator('reseedFixedDatesList', {
              initialValue: this.state.selectedMultipleDates,
              rules: [{required: true}]
              })(
            <Select mode="tags" onChange={this.selectedDatesChange.bind(this)}  style={{ width: '100%' }} placeholder="Select the dates" optionLabelProp="label">
              <Option value=''></Option>
           </Select>
            )}
        </Form.Item>:''}
     
       {data.reseedType == 'FIXED' ?       
            <Form.Item name="reseedFixedDates" >
              <DatePicker format={'YYYY-MM-DD'} onChange={this.selectReseedFixedDates}/>
         </Form.Item>:''}


         {data.reseedType == 'BASEDONATASK' ?  
         <Form.Item label="Based on the Task"  name="abstractTaskId">
         {getFieldDecorator('abstractTaskId', {
              initialValue:data.abstractTaskId,
              rules: [{required: true}]
            })(
            <Select showSearch placeholder="Select a task" optionFilterProp="children">
            {selectTasks != "" ? selectTasks.map(value =>  <Option value={value.id}>{value.name}</Option>) : <Option value=''>''</Option>}
            </Select>
            )}
        </Form.Item> : ''}
        {data.reseedType == 'BASEDONATASK' || data.reseedType == 'BASEDONTHELASTUPDATEDATE' ?  
        <Form.Item label="Recycle Period"  name="RecyclePeriod" >
         {getFieldDecorator('recyclePeriod', {
             initialValue:data.recyclePeriod,
             rules: [{required: true}]
            })(
             <InputNumber style={{ width: '100%' }} onChange={this.onchangeRecyclePeriod}/>
            )}
         </Form.Item> :''}
        {/* <Form.Item label="Author Period"  name="AuthorPeriod" >
         {getFieldDecorator('authorPeriod', {
             initialValue:data.authorPeriod,
             rules: []
            })(
             <InputNumber style={{ width: '100%' }} />
            )}
         </Form.Item>  */}
          {data.projectStartDate != '' && data.projectStartDate != null?
          <Form.Item label="Last Updated Date"  name="lastUpdatedDate" >
            {getFieldDecorator('lastUpdatedDate', {
                  initialValue:(data.lastUpdatedDate != null ? moment(data.lastUpdatedDate, 'YYYY-MM-DD'):'')
                })(
              <DatePicker style={{ width: '100%' }}  onChange={this.onChangeLastUpdatedDate}  format={'YYYY-MM-DD'} />
            )}
         </Form.Item>:''}
        
         <Form.Item label="Last Published Date"  name="lastPublishedDate" >
         {getFieldDecorator('lastPublishedDate', {
                  initialValue:(data.lastPublishedDate != null ? moment(data.lastPublishedDate, 'YYYY-MM-DD'):'')
                })(
              <DatePicker style={{ width: '100%' }} onChange={this.onChangelastPublishedDate} format={'YYYY-MM-DD'} />
            )}
         </Form.Item>
         

         <Form.Item label="Request Date"  name="RequestDate" >
            {getFieldDecorator('projectStartDate', {
                  initialValue:(data.projectStartDate != null ? moment(data.projectStartDate, 'YYYY-MM-DD'):'')
                })(
              <DatePicker style={{ width: '100%' }}  format={'YYYY-MM-DD'} />   
            )}
         </Form.Item>
         {/* <Form.Item label="Send files to author on"  name="Sendfilestoauthoron" >
         {getFieldDecorator('filesToAuthorDate', {
             initialValue:(data.filesToAuthorDate != null ? moment(data.filesToAuthorDate, 'YYYY-MM-DD'):'')
                })(
              <DatePicker style={{ width: '100%' }} onChange={this.getFileToAuthor.bind(this)} format={'YYYY-MM-DD'} />
                )}
         </Form.Item>
         <Form.Item label="Expect files from author on"  name="Expectfilesfromauthoron" >
         {getFieldDecorator('filesFromAuthorDate', {
             initialValue:(data.filesFromAuthorDate != null ? moment(data.filesFromAuthorDate, 'YYYY-MM-DD'):'')
                })(
              <DatePicker style={{ width: '100%' }} format={'YYYY-MM-DD'}/>
                )}
         </Form.Item> */}
         {/* <Form.Item label="IFP Date"  name="IFPDate" >
         {getFieldDecorator('ifpDate', {
              initialValue:(data.ifpDate != null ? moment(data.ifpDate, 'YYYY-MM-DD'):'')
                })(
             <DatePicker style={{ width: '100%' }} format={'YYYY-MM-DD'}/>
                )}
         </Form.Item>
         <Form.Item label="CMP Date"  name="CMPDate" >
         {getFieldDecorator('cmpDate', {
             initialValue:(data.cmpDate != null ? moment(data.cmpDate, 'YYYY-MM-DD'):'')
                })(
             <DatePicker style={{ width: '100%' }} format={'YYYY-MM-DD'}/>
                )}
         </Form.Item> */}

        <Form.Item>
          <Button style={{"float":"right","margin-top":"10px"}} type="primary"  htmlType="submit" className="login-form-button">Update </Button>
        </Form.Item>
        {/* <Button style={{"float":"right","margin-top":"10px","color":"#fff","background-color":"green","border-color":"green"}} type="success" onClick={() => this.onclickFinalized()}>Finalize</Button><br/><br/> */}
      </Form>
     
    );
  }
}

export default Form.create({ name: 'normal_login' })(LooseLeafSchedulerDrawer);

// export default WrappedNormalLoginForm;

